import { createTheme } from '@mui/material/styles';
const theme = createTheme({
  palette: {
    primary: {
      main: '#5A7FF8',
    },
    secondary: {
      main: '#86A2FF',
    },
    text: {
      primary: '#1A202C',
      secondary: '#90A3BF',
    },
  },
  typography: {
    fontFamily: 'Figtree, sans-serif',
  },
});
export default theme;
